import { render, staticRenderFns } from "./createbillperiod.vue?vue&type=template&id=cbb737e6&"
import script from "./createbillperiod.vue?vue&type=script&lang=ts&"
export * from "./createbillperiod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createbillperiod.vue"
export default component.exports